(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/coupon/reduction/reductions.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/coupon/reduction/reductions.js');

'use strict';

svs.matchen = svs.matchen || {};
svs.matchen.views = svs.matchen.views || {};

svs.matchen.views.Reductions = Marionette.CollectionView.extend({
  options: {
    xperten: false
  },

  className: 'view-reductions reductions align-center',

  childViewContainer: '.reduction-toggles',

  childView: svs.matchen.views.Reduction,

  template: function() {
    return svs.matchen.templates.reductions();
  },

  events: {
    'click .js-help-dialog-reduce': 'helpDialogReduce'
  },

  helpDialogReduce: function(e) {
    if (svs.matchen.data.matchenconfig.helpTexts) {
      var _dialog = new svs.components.dialog.Contextual({
        branding: svs.components.dialog.branding.SPORT,
        attachTo: $(e.currentTarget),
        zIndex: 1000,
        title: svs.matchen.data.matchenconfig.helpTexts.reduce.title,
        message: [
          {
            type: svs.components.dialog.message.TEXT,
            text: svs.matchen.data.matchenconfig.helpTexts.reduce.body
          }
        ]
      });
      svs.components.dialog.api.add(_dialog);
    }
  }
});


 })(window);